const analysisMethod =
{
    tooltips :
    {
        mandatory : 'Obligatoire'
    },
    unknown : 'Inconnu'
};

export default analysisMethod ;